import {Autocomplete, CircularProgress, TextField} from "@mui/material";
import useResponsive from "../../../components/hooks/useResponsive";

const HistoryFormAutoComplete = ({
                                     options,
                                     value,
                                     setValue,
                                     isDisable,
                                     placeholder,
                                     isLoading
}) => {

    const {isXs} = useResponsive();

    const onChangeHandler = (event, value) => {
        setValue(value || "");
    };

    return (
        <Autocomplete
            sx={{
                width: isXs ? "100%" : "250px",
            }}
            options={options || []}
            value={value || null}
            onChange={onChangeHandler}
            getOptionLabel={(option) => option}
            isOptionEqualToValue={(option, value) => option === value}
            renderInput={(params) => (
                <TextField
                    {...params}
                    placeholder={placeholder}
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {isLoading ? (
                                    <CircularProgress color="inherit" size={20}/>
                                ) : null}
                                {params.InputProps.endAdornment}
                            </>
                        ),
                    }}
                />
            )}
            fullWidth
            disabled={isDisable}
            noOptionsText="نتیجه‌ای یافت نشد"
        />
    );
};

export default HistoryFormAutoComplete;